module.exports = __webpack_public_path__ + "img/nt112-05-85-1.prt.89c9e9a7.jpg";